import heic2any from "heic2any";

export const compressImage = async (file, maxWidth = 1200, quality = 0.7) => {
  let workingFile = file;

  // 🔹 HEIC in JPEG umwandeln
  if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
    const convertedBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.8
    });

    workingFile = new File(
      [convertedBlob],
      file.name.replace(/\.heic$/i, ".jpg"),
      { type: "image/jpeg" }
    );
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

        let { width, height } = img;

        if (width > maxWidth) {
          height = height * (maxWidth / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;

        // Weißer Hintergrund gegen Transparenz
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, width, height);

        ctx.drawImage(img, 0, 0, width, height);

        const compressed = canvas.toDataURL("image/jpeg", quality);
        resolve(compressed);
      };

      img.onerror = reject;
      img.src = e.target.result;
  };

    reader.onerror = reject;
    reader.readAsDataURL(workingFile);
  });
  };



export async function convertHeicIfNeeded(file) {
  if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
    const convertedBlob = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.8
    });

    return new File(
      [convertedBlob],
      file.name.replace(/\.heic$/i, ".jpg"),
      { type: "image/jpeg" }
    );
  }

  return file;
}